module.exports = require('./src/Map.SelectArea');

